import { FormField } from "@common/types";
import { NONEOption } from "@product-pages/model/options/common";
import { DescriptionList } from "@vwfs-bronson/bronson-react";
import { useField } from "formik";

interface Props {
  formField: FormField;
  termText: string;
  formatter?: (value: string) => string;
  showIfEmpty?: boolean;
  booleanValue?: boolean;
  children?: React.ReactNode;
}

export const DescriptionListItem = ({ formField, termText, formatter, showIfEmpty, booleanValue }: Props) => {
  const [{ value }] = useField<string>(formField.fieldName);

  return (value && value !== NONEOption) || showIfEmpty || booleanValue ? (
    <DescriptionList.Group termText={termText}>
      <DescriptionList.Detail>{formatter ? formatter(value) : value}</DescriptionList.Detail>
    </DescriptionList.Group>
  ) : null;
};
